import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: '蘭恩夥伴'
	}
});

export default app;